(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-atlas-soins-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Glisser-deposer a la souris sur le rail. Portee limitee aux sections
  // [data-ma-soins] : l'ancien selecteur [data-section-id] balayait toutes
  // les sections de la page pour n'en retenir qu'une.
  function brancher(section) {
    var track = section.querySelector('.ma-soins__track');
    if (!track || track.dataset.maDrag === '1') return;
    track.dataset.maDrag = '1';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      if (e.target.closest('a, button, form')) return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function brancherTous(portee) {
    var noeuds = (portee || document).querySelectorAll('[data-ma-soins]');
    for (var i = 0; i < noeuds.length; i++) brancher(noeuds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { brancherTous(); });
  } else {
    brancherTous();
  }
  document.addEventListener('shopify:section:load', function (e) { brancherTous(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
